import { IHasID } from 'types';
import { ID } from 'types/pigeon';

export function useSelectedItems<T extends IHasID>(A: T[], ids: Set<ID>) {
  return A.filter(x => ids.has(x.id));
}
